module.exports = __webpack_public_path__ + "img/warning-time.8e1e1267.svg";